export default "__VITE_ASSET__D0VlWh_8__"